import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoginModule, LoginRoutes} from 'web-shared';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LoginModule,
    RouterModule.forChild(LoginRoutes)
  ]
})
export class MetecLoginModule { }
